import React, { useRef } from "react";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import ScrollToTopButton from "./ScrollToTopButton";

function SmallContact() {
  const ref = useRef();
  useScrollPosition(({ currPos }) => {
    if (!ref.current) return;
    if (currPos.y <= -300) {
      ref.current.className = "w-5";
    } else if (currPos.y <= 0 && currPos.y >= -300) {
      ref.current.className = "hidden";
    }
  });

  return (
    <div ref={ref} className="hidden">
      <a
        href="#nav"
        className="fixed bottom-6 end-5 z-30 sm:bottom-8"
        aria-label="Scroll to top"
      >
        <div className="relative h-9 w-7 rounded-full bg-[#44444480]">
          <ScrollToTopButton />
        </div>
      </a>
    </div>
  );
}

export default SmallContact;
